<template>
  <div class="fc-notification-legend" data-testid="notification-legend">
    <span class="fc-notification-legend__item">
      <NotificationKindBadge kind="schedule" />
      runs at a set time (frequency 24h, not editable)
    </span>
    <span class="fc-notification-legend__item">
      <NotificationKindBadge kind="trigger" />
      sends when it happens
    </span>
    <span class="fc-notification-legend__item">
      <v-icon x-small class="fc-notification-legend__help-icon">mdi-help-circle-outline</v-icon>
      hover for the next 5 runs
    </span>
    <span class="fc-notification-legend__item">
      Actions: Edit · View run history · Audit · Delete (no test send, no preview)
    </span>
  </div>
</template>

<script>
import NotificationKindBadge from '../NotificationKindBadge/NotificationKindBadge.vue';

export default {
  name: 'NotificationLegend',
  components: { NotificationKindBadge },
};
</script>
